export default __webpack_public_path__ + "static/media/ds.ae4beefe.png";